import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import useHasPermission from 'app/hooks/useHasPermission/useHasPermission'
import RegionalGroupCreate from 'app/Apps/AccountManagement/Accounts/RegionalGroups/RegionalGroupCreateForm'

import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'

import request from 'app/requests/RegionalGroup.requests'
import Overview from './Overview'
import tableConfig from './regionalGroups.config'
import UpdateData from './UpdateData'
import Opportunities from './Opportunities'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const RegionalGroups = () => {
    const {
        RegionalGroups: RegionalGroupsRoutes,
    } = useAccountManagementRoutes()
    const updatePermission = useHasPermission(['account_update_all'])
    const canCreateRegionGroup = useHasPermission(['account_create_all'])

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: 'Overview',
                url: RegionalGroupsRoutes.Overview.route,
                Component: Overview,
            },
            permission: true,
        },
        {
            tab: {
                label: 'Update Data',
                url: RegionalGroupsRoutes.Update.route,
                Component: UpdateData,
            },
            permission: updatePermission,
        },
        {
            tab: {
                label: 'Opportunities',
                url: RegionalGroupsRoutes.Opportunities.route,
                Component: Opportunities,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            sidebarTabs={tabs}
            defaultTab={RegionalGroupsRoutes.Overview.route}
            name={tableConfig.name}
            actionComponents={{
                Create: canCreateRegionGroup ? RegionalGroupCreate : undefined,
            }}
        >
            <SkyNetTable
                moduleName={request.domainName}
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default RegionalGroups
